import { FaListUl } from 'react-icons/fa';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';


class CustomData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            filterBy: {},
            sortBy: 'name',
            sortOrder: 1,
            loading: false,
            type: "special",
            category: ''
        };
    }
    cancel = () => {
        this.setState({ editData: false, tempData: false, loading: false, error: '' })
    }
    editData = (id) => e => {
        var item = this.props.data.CustomData.data.find(function (element) {
            return element.id === id;
        });
        this.setState({ editData: true, tempData: item, loading: false, error: '' })
    }
    // add = () => {
    //     this.setState({ editData: true, promptID: null, loading: false, error: '' })
    // }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    toggle = (param) => (e) => {
        var newState = Object.assign({}, this.state)
        newState[param] = this.state[param] ? false : true
        this.setState(newState)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }
    handleTempDataValueChange = (e, index) => {
        const newValue = e.target.value;

        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            if (Array.isArray(updatedTempData.value)) {
                updatedTempData.value[index] = newValue;
            } else {
                updatedTempData.value = newValue;
            }
            return { tempData: updatedTempData };
        });
    }
    deleteArrayItem = (index) => () => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = [...updatedTempData.value];
            updatedTempData.value.splice(index, 1);
            return { tempData: updatedTempData };
        });
    }

    toggleTempDataValue = (e) => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = !updatedTempData.value;
            return { tempData: updatedTempData };
        })
    }

    ensureDefaultCategory = (props) => {
        try {
            const categories = props?.data?.CustomData?.settings?.categoires;

            if (Array.isArray(categories) && categories.length > 0) {
                // If no category has been chosen yet (initial render), or current category is no longer valid,
                // default to the first category so the list renders filtered/sorted correctly.
                if (!this.state.category || !categories.includes(this.state.category)) {
                    this.setState({ category: categories[0] });
                }
            } else {
                // No categories available; clear selection
                if (this.state.category) {
                    this.setState({ category: '' });
                }
            }
        } catch (e) {
            // no-op
        }
    }

    componentDidMount() {
        this.ensureDefaultCategory(this.props);
    }

    componentDidUpdate(prevProps) {
        // If categories are loaded/changed after initial render, ensure we pick a valid default.
        const prevCats = prevProps?.data?.CustomData?.settings?.categoires;
        const nextCats = this.props?.data?.CustomData?.settings?.categoires;

        const prevKey = Array.isArray(prevCats) ? prevCats.join('|') : '';
        const nextKey = Array.isArray(nextCats) ? nextCats.join('|') : '';

        if (prevKey !== nextKey) {
            this.ensureDefaultCategory(this.props);
        }
    }

    isIsoZTimestamp = (v) => {
        if (typeof v !== 'string') return false;
        // Basic check: ISO datetime containing 'T' and ending with 'Z'
        if (v.indexOf('T') < 0) return false;
        if (!v.endsWith('Z')) return false;
        // Ensure it parses to a valid date
        const d = new Date(v);
        return !isNaN(d.getTime());
    }

    handleTempDataDateChange = (date) => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = date ? date.toISOString() : '';
            return { tempData: updatedTempData };
        });
    }

    confirmEdit = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempData = this.state.tempData
        tempData.creationDate = new Date().toJSON()
        this.props.ws.send(JSON.stringify({ route: 'updateCustomData', data: tempData }))
        //update state to not be editing
        this.setState({ editData: false, loading: false, tempData: null })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    checkCategory = (e) => {
        console.log(e.target.value)
        this.setState({ category: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })
    }

    formatEastern(date) {
        try {
            if (!date) return '';
            const d = new Date(date);
            if (isNaN(d)) return date;

            return d.toLocaleString('en-US', {
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            });
        } catch (e) {
            return date;
        }
    }

    render() {
        if (this.props.active) {


            const categories = (this.props.data.CustomData.settings.categoires && this.props.data.CustomData.settings.categoires.length > 0) ? this.props.data.CustomData.settings.categoires : false
            //if categories is true and             // if (this.state.category === "" || this.state.category === undefined) {
            console.log(categories)
            // If categories are missing, we simply won't render the dropdown and won't filter by category.

            var dataList = []
            var CustomData = JSON.parse(JSON.stringify(this.props.data.CustomData.data));
            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                CustomData = this.filterFunc(CustomData, this.state.filterBy)
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                CustomData.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            //Filter data by type 
            if (this.state.category !== "" && this.state.category !== undefined && this.state.category !== false) {
                console.log("Filtering by category")

                CustomData = CustomData.filter(function (object) {
                    console.log(object.category)
                    console.log(this.state.category)
                    return object.category === this.state.category
                }, this)
            }

            const recordCount = CustomData.length;

            const showSidebar = recordCount >= 10;
            const showCategoryDropdown = categories && categories.length > 0;
            const showTopCategoryBar = !showSidebar && showCategoryDropdown;

            const leftPanelStyle = showSidebar
                ? { width: '200px', marginRight: '50px', marginTop: '2px' }
                : { width: '0px', marginRight: '0px', marginTop: '2px' };

            const renderCategoryDropdown = () => {
                if (!showCategoryDropdown) return null;
                return (
                    <select
                        value={this.state.category}
                        onChange={this.checkCategory}
                        style={{
                            display: 'inline-block',
                            width: '250px',
                            marginBottom: '5px',
                            height: '40px',
                            padding: '0 10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '20px',
                            color: '#137',
                            lineHeight: '24px'
                        }}
                    >
                        {categories.map((category, index) => (
                            <option key={index} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>
                );
            };

            for (var data of CustomData) {
                dataList.push(
                    <tr className="dataRow" onClick={this.editData(data.id)} key={data.id}>
                        <td style={{ minWidth: '320px', textAlign: 'left' }}>{data.name}</td>
                        <td style={{ minWidth: '260px', textAlign: 'left' }}>
                            {Array.isArray(data.value) ? <FaListUl style={{ marginRight: '5px' }} /> : ''}
                            {(Array.isArray(data.value)
                                ? ""
                                : this.isIsoZTimestamp(data.value)
                                    ? this.formatEastern(data.value)
                                    : data.value
                            )}
                            {typeof data.value === 'boolean' ? (data.value ? "Active" : "Inactive") : ""}
                        </td>
                        <td style={{ minWidth: '180px', textAlign: 'left' }}>{data.lastUpdatedUser}</td>
                        <td style={{ minWidth: '250px', textAlign: 'right' }}>{data.lastUpdatedDate}</td>
                    </tr>
                );
            }

            var editData = "";
            if (this.state.editData) {
                let inputElements = null;

                if (Array.isArray(this.state.tempData.value)) {
                    const arrayItems = this.state.tempData.value.map((item, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '8px' }}>
                            <input
                                type="text"
                                value={item}
                                onChange={(e) => this.handleTempDataValueChange(e, index)}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                            />
                            <button
                                onClick={this.deleteArrayItem(index)}
                                title="Remove item"
                                style={{
                                    background: '#b02a37',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    width: '30px',
                                    height: '34px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    lineHeight: '34px',
                                    padding: 0
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    ));

                    // Add an empty input box to allow adding new items
                    arrayItems.push(
                        <div key={this.state.tempData.value.length} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '8px' }}>
                            <input
                                type="text"
                                value=""
                                placeholder="Add new item..."
                                onChange={(e) => this.handleTempDataValueChange(e, this.state.tempData.value.length)}
                                ref={this.newInput}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                            />
                            <div style={{ width: '30px' }} />
                        </div>
                    );

                    inputElements = (
                        <div style={{ maxHeight: '50vh', overflowY: 'auto', width: '100%', padding: '4px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {arrayItems}
                        </div>
                    );
                } else if (typeof this.state.tempData.value === 'boolean') {
                    inputElements = (
                        <select
                            value={this.state.tempData.value}
                            onChange={this.toggleTempDataValue}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                        >
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>
                        </select>
                    );
                } else if (this.isIsoZTimestamp(this.state.tempData.value)) {
                    const selectedDate = this.state.tempData.value ? new Date(this.state.tempData.value) : null;
                    inputElements = (
                        <div style={{ marginBottom: '10px', width: '250px' }}>
                            <DatePicker
                                selected={selectedDate}
                                onChange={this.handleTempDataDateChange}
                                showTimeSelect
                                timeIntervals={5}
                                popperProps={{ strategy: 'fixed' }}
                                dateFormat="yyyy-MM-dd HH:mm"
                                placeholderText="Select date & time"
                                className="datePicker"
                                wrapperClassName="datePickerWrapper"
                                popperPlacement="top-start"
                                style={{ width: '250px' }}
                            />
                        </div>
                    );
                } else if (typeof this.state.tempData.value === 'number') {
                    // Input field for integer numbers
                    inputElements = (
                        <input
                            type="number"
                            value={this.state.tempData.value}
                            onChange={this.handleTempDataValueChange}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            step="1"  // Ensure the input only allows integers
                        />
                    );
                } else {
                    if (this.state.tempData.options != undefined) {
                        // Build out options for dropdown
                        var options = []
                        for (var option of this.state.tempData.options) {
                            options.push(<option value={option}>{option}</option>)
                        }

                        inputElements = (
                            <select
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            >
                                {options}
                            </select>
                        );
                    } else {
                        inputElements = (
                            <input
                                type="text"
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            />
                        );
                    }
                }

                editData = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '520px',
                            maxWidth: '92vw',
                            maxHeight: '90vh',
                            padding: '45px',
                            overflow: 'visible',
                            position: 'relative'
                        }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div className="error">{this.state.error}</div>

                            {/* Display the current tempData Name */}
                            <h2 style={{ marginBottom: '1px', fontSize: '1.5rem', textAlign: 'center' }}>
                                {this.state.tempData.name}
                            </h2>

                            {/* Display the tempData Description (Non-editable, text wraps) */}
                            <p style={{
                                marginBottom: '30px',
                                fontSize: '1rem',
                                color: '#666',
                                textAlign: 'center',
                                wordWrap: 'break-word',   // Ensure long words break and wrap
                                whiteSpace: 'normal'      // Allow regular text wrapping
                            }}>
                                {this.state.tempData.description}
                            </p>

                            {/* Edit box for the value */}
                            {inputElements}

                            {/* Confirm button */}
                            <button className="button" onClick={this.confirmEdit} style={{ border: 'none', cursor: 'pointer' }}>
                                Confirm
                            </button>
                        </div>
                    </div>
                );
            }

            return (
                <div width="100%">
                    {showTopCategoryBar && (
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            marginTop: '10px',
                            marginBottom: '15px'
                        }}>
                            {renderCategoryDropdown()}
                        </div>
                    )}

                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={leftPanelStyle}>
                            {showSidebar && (
                                <div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
                                    <label className="switch">
                                        <div style={{ width: '250px' }}>
                                            {renderCategoryDropdown()}
                                        </div>
                                    </label>
                                </div>
                            )}
                            {showSidebar && (
                                <div className="filterBox" style={{
                                    "width": "210px"
                                }}>

                                    <h4>Filter By:</h4>
                                    <div style={{ width: '150px' }}>
                                        <label>Name:</label>
                                        <input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
                                    </div>
                                    <div style={{ width: '150px' }}>
                                        <label>User:   </label>
                                        <input type="text" onChange={this.filter("lastUpdatedUser")} value={this.state.filterBy.User} />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ float: "left", width: '100%' }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ minWidth: '320px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                                        <th style={{ minWidth: '260px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("value")}>Value {this.filterIcon("value")}</th>
                                        <th style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("lastUpdatedUser")}>Last Updated User {this.filterIcon("lastUpdatedUser")}</th>
                                        <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastUpdatedDate")}>Last Updated {this.filterIcon("lastUpdatedDate")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editData}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}


const icon = "menuGear"
const roles = ["View"]
export { CustomData, icon, roles }